const Cols = (props) => (
	<colgroup>
		<col className='checklist-col-1' />
		<col className='checklist-col-2' />
		<col className='checklist-col-3' />
		<col className='checklist-col-4' />
		{props.rating === 'yes-no' ? null : <col className='checklist-col-5' />}
	</colgroup>
)

export default Cols
